<template>
  <adv-input-spinner
    :min="productCodeData.productStock > 0 ? 1 : 0"
    :max="productCodeData.productStock"
    :quantity="localQuantity"
    :button-css="buttonCss"
    :unavailable="!this.productCodeId || productCodeData.productStock <= 0"
    v-on:quantity-changed="quantityChanged"></adv-input-spinner>
</template>

<script>
import AdvInputSpinner from './presentation/AdvInputSpinner'
import productMixin from './mixins/productMixins'
import store from '../../vue/store'

export default {
  name: 'AdvCartInputSpinner',
  props: ['productCodeId', 'unavailable', 'quantity', 'buttonCss'],
  components: {
    AdvInputSpinner
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.1',
      localQuantity: 0
    }
  },
  mounted () {
    this.localQuantity = this.quantity
  },
  watch: {
    productCodeId (val) {
      this.localQuantity = this.productCodeData.productStock > 0 ? store.getters.cartSpinnerQuantity(val) : 0
    },
    quantity (val) {
      this.localQuantity = val
    }
  },
  methods: {
    debounce (func, wait) {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(func, wait)
    },
    quantityChanged (quantity) {
      this.localQuantity = quantity
      this.debounce(() => {
        this.localQuantity = quantity
        this.$emit('quantity-changed', quantity)
      }, 200)
    }
  }
}
</script>
